import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PessoaTipoMultiselectModule } from '../../tipo/multiselect';
import { ClienteCentralCompraTypeaheadModule } from '../central-compra/typeahead/cliente-central-compra-typeahead.module';
import { RepresentanteSharedModule } from '../../representante';
import { RepresentanteMultiselectModule } from '../../representante/multiselect';
import { CidadeModule } from '../../../cidade';
import { ClienteAnaliseFinanceiraStatusMultiselectModule } from '../analise-financeira/status/multiselect';
import { ClassificacaoTipoMultiselectModule } from '../../../classificacao/tipo/multiselect';
import { ClienteCadastroMultiselectModule } from '../cadastro/multiselect';
import { ClienteSituacaoMultiselectModule } from '../situacao/multiselect';
import { OrigemMultiselectModule } from '../../../common/origens/components/multiselect';
import { CampanhaMultiselectModule } from '../../../campanhas/campanhas/components/multiselect';
import { CanalMidiaSocialmMultiselectModule } from '../../../common/canal-midia-social/components/multiselect';
import { RegiaoMultiselectModule } from '../../../regiao/multiselect';
import { CanalVendaMultiselectModule } from '../../../common/canais-venda/components/multiselect';

import { ClienteFilterComponent } from './cliente-filter.component';

@NgModule({
    imports: [
        SharedModule,
        PessoaTipoMultiselectModule,
        ClienteCentralCompraTypeaheadModule,
        RepresentanteSharedModule,
        RepresentanteMultiselectModule,
        ClienteAnaliseFinanceiraStatusMultiselectModule,
        CidadeModule,
        ClassificacaoTipoMultiselectModule,
        ClienteCadastroMultiselectModule,
        ClienteSituacaoMultiselectModule,
        OrigemMultiselectModule,
        CampanhaMultiselectModule,
        CanalMidiaSocialmMultiselectModule,
        RegiaoMultiselectModule,
        CanalVendaMultiselectModule
    ],
    declarations: [
        ClienteFilterComponent
    ],
    exports: [
        SharedModule,
        ClienteFilterComponent
    ]
})
export class ClienteFilterModule { }
